import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Marsa_Al_Arab.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Marsa Al Arab</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A landmark ultra-luxury resort development extending the iconic Jumeirah Beach Hotel precinct, featuring a private island,
                luxury residences, marina, spa and new hospitality venues. One of Dubai's most significant new hospitality additions in recent
                years.</p>
              <p>MAIN CONTRACTOR : Al Shafar</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : Plumbing network works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one